import { parseISO } from "date-fns"

import type { Touched } from "../../types"
import type EstimateValues from "../../types/params"

const PBAN_SESSION_STORAGE_KEY = "1CLICK_ESTIMATE_TEMP"

const temporaryStorage = {
  save(state: {
    values: EstimateValues
    touched: Touched
    bomSnapshotId: string | null
    deliveryZeroFlg: boolean
    mountQuickFlg: boolean
  }): void {
    try {
      sessionStorage.setItem(PBAN_SESSION_STORAGE_KEY, JSON.stringify(state))
    } catch {}
  },
  restore(): {
    values: Partial<EstimateValues>
    touched: Touched
    bomSnapshotId: string | null
    deliveryZeroFlg: boolean
    mountQuickFlg: boolean
  } {
    try {
      const stateString = sessionStorage.getItem(PBAN_SESSION_STORAGE_KEY)
      sessionStorage.removeItem(PBAN_SESSION_STORAGE_KEY)

      const { values, touched, bomSnapshotId, deliveryZeroFlg, mountQuickFlg } = JSON.parse(stateString ?? "")
      return {
        values: {
          ...values,
          materialsArrivalDate: parseISO(values.materialsArrivalDate),
        },
        touched,
        bomSnapshotId,
        deliveryZeroFlg,
        mountQuickFlg,
      }
    } catch {}

    return { values: {}, touched: {}, bomSnapshotId: null, deliveryZeroFlg: false, mountQuickFlg: false }
  },
}

export default temporaryStorage
